import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import config from "../../config";
import GifLoder from '../../components/GifLoder';
import { Row, Col, Card, Breadcrumb, Tab, Tabs, Modal, Form, Badge } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import moment from "moment";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import { Tag } from 'primereact/tag';

const Client_Project_Page = () => {
    const { accessToken } = useAuth();
    const [projects, setProjects] = useState({});
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(null);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [modalStep, setModalStep] = useState('choose'); // 'choose', 'projectStatus', 'paymentStatus'
    const [brands, setBrands] = useState([]);
    const [brandSuggestions, setBrandSuggestions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [selectedProject, setSelectedProject] = useState("");
    const [addprojects, setaddProjects] = useState([]);
    const [projectName, setProjectName] = useState('');
    const [estimatedDeadline, setEstimatedDeadline] = useState(null);
    const [filters, setFilters] = useState({ start_date: moment().startOf("month").format("YYYY-MM-DD"), end_date: moment().endOf("month").format("YYYY-MM-DD"), Billing_name: '', });
    const [dateRange, setDateRange] = useState({ startDate: moment().startOf("month"), endDate: moment().endOf("month") });
    const fetchProjects = async () => {
        try {
            setLoading(true);
            const queryParams = new URLSearchParams();
            Object.entries(filters).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });

            const response = await axios.get(`${config.apiBASEURL}/ClientFormRoutes/accepted-projects?${queryParams.toString()}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                const projectData = response.data.data;
                setProjects(projectData);

                // Dynamically set the first tab as active
                const firstTab = Object.keys(projectData)[0];
                if (firstTab) setActiveTab(firstTab);
            }
            else if (response.status === 204) {
                setProjects({
                    Accepted: { assignedProjects: [], unassignedProjects: [] },
                    Work_under_progress: { assignedProjects: [], unassignedProjects: [] },
                    Completed: { assignedProjects: [], unassignedProjects: [] },
                    On_Hold: { assignedProjects: [], unassignedProjects: [] },
                    Rejected: { assignedProjects: [], unassignedProjects: [] },
                });
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, [ accessToken]);
    

    const handleApplyFilters = () => {
        fetchProjects();
    };



    const handleDateRangeChange = (start, end) => {
        setFilters({ ...filters, start_date: start.format("YYYY-MM-DD"), end_date: end.format("YYYY-MM-DD") });
        setDateRange({ startDate: start, endDate: end });
    };



    const fetchBrandsAndProjects = async (search) => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/projectRoutes/projects-by-brand?brand_name=${search}`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            if (response.data && response.data.projects) {
                const projects = response.data.projects;
                const uniqueBrands = Array.from(
                    new Map(
                        projects.map((project) => [
                            project.brand.brand_name,
                            { id: project.brand_id, name: project.brand.brand_name },
                        ])
                    ).values()
                );
                setBrands(uniqueBrands);
                setaddProjects(projects);
            }
        } catch (error) {
            console.error("Error fetching brands/projects:", error);
        }
    };

    const searchBrands = (event) => {
        const query = event.query.toLowerCase();
        const filteredBrands = brands.filter((brand) =>
            brand.name.toLowerCase().includes(query)
        );
        setBrandSuggestions(filteredBrands);
    };


    // Handle project selection
    useEffect(() => {
        if (selectedProject) {
            const project = addprojects.find((p) => p.project_id === selectedProject);
            if (project) {
                setProjectName(project.project_name);
            }
        }
    }, [selectedProject, addprojects]);



    const handleLinkToEmployeeProject = (projectId) => {
        setSelectedProjectId(projectId);
        setShowLinkModal(true);
    };

    const handleUpdateStatus = (projectId) => {
        setSelectedProjectId(projectId);
        setModalStep('choose');
        setShowStatusModal(true);
    };


    const handleProjectStatusUpdate = async (status) => {
        try {
            const response = await axios.put(`${config.apiBASEURL}/ClientFormRoutes/accepted-projects/${selectedProjectId}/update-status`, { project_status: status }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            if (response.data.success) {
                setShowStatusModal(false);
                setSelectedProjectId(null);
                fetchProjects();
            }

        } catch (error) {
            console.error('Error updating project status:', error);
        }
    };

    const handlePaymentStatusUpdate = async (status) => {
        try {
            const response = await axios.put(`${config.apiBASEURL}/ClientFormRoutes/accepted-projects/${selectedProjectId}/update-payment-status`, { payment_status: status }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            if (response.data.success) {
                setShowStatusModal(false);
                setSelectedProjectId(null);
                fetchProjects();
            }
        } catch (error) {
            console.error('Error updating payment status:', error);
        }
    };


    // Handle submit
    const handleSubmit = async () => {
        try {
            const response = await axios.put(`${config.apiBASEURL}/ClientFormRoutes/accepted-projects/${selectedProjectId}/update-details`, {
                project_name: projectName,
                project_id: selectedProject,
                estimated_date: estimatedDeadline
            }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data.success) {
                setShowLinkModal(false);
                setProjectName('');
                setSelectedProject('');
                setEstimatedDeadline(null);
                setSelectedProjectId(null);
                fetchProjects();
            } 
        } catch (error) {
            console.error('Error updating project details:', error);

        }
    };


    /*--------------Status Tag---------------------*/

    const getStatusClass = (status) => {
        switch (status) {
            case 'Accepted':
            return 'success';  // Green
        case 'Work_under_progress':
            return 'info';  // Blue
        case 'Completed':
            return 'success';  // Green
        case 'On_Hold':
            return 'warning';  // Orange
        case 'Rejected':
            return 'danger';  // Red
        default:
            return 'secondary';  // Gray (default)
        }
    };


    /*----------------------Price Status-----------------------*/

    const getStatusSeverity = (status) => {
        switch (status) {
            case 'Payment_due':
                return 'danger';  // Red
            case 'Payment_Completed':
                return 'success';  // Green
            case 'Partial_Payment':
                return 'warning';  // Orange
            case 'Refunded':
                return 'secondary';  // Blue
            default:
                return 'secondary';  // Gray (default)
        }
    };



    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className='body_content'>
                    <Row className='mx-0'>
                        <Col md={12} lg={2} className='mb-4 d-flex justify-content-between align-items-center'>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Client Projects</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col md={12} lg={10} className='mb-4 d-flex flex-wrap justify-content-lg-end align-items-center gap-2'>
                            <DateRangePicker
                                key={`${dateRange.startDate}-${dateRange.endDate}`}
                                initialSettings={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                    locale: { format: "DD/MM/YYYY" },
                                    ranges: {
                                        Today: [moment(), moment()],
                                        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                        "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                        "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                        "This Month": [moment().startOf("month"), moment().endOf("month")],
                                        "Last Month": [
                                            moment().subtract(1, "month").startOf("month"),
                                            moment().subtract(1, "month").endOf("month"),
                                        ],
                                    },
                                }}
                                onCallback={handleDateRangeChange}

                            >
                                <button className="btn btn-outline-secondary">
                                    {dateRange.startDate.format("DD/MM/YYYY")} - {dateRange.endDate.format("DD/MM/YYYY")}
                                </button>
                            </DateRangePicker>

                            <InputText
                                value={filters.Billing_name}
                                onChange={(e) => setFilters({ ...filters, Billing_name: e.target.value })}
                                placeholder="Client/Billing Name"
                                style={{ width: '200px', height: '36px' }}

                            />
                            <Button label="Apply" onClick={handleApplyFilters} className='p-button-primary py-2' style={{ height: '36px' }} />
                           
                        </Col>
                        <Col lg={12}>
                            {activeTab && (
                                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                                    {Object.keys(projects).map((status) => {
                                        const assignedProjects = projects[status].assignedProjects || [];
                                        const unassignedProjects = projects[status].unassignedProjects || [];

                                        return (
                                            <Tab eventKey={status} title={status} key={status}>
                                                <Card className="p-0 shadow-sm" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                                    <Row className="mx-0">
                                                        {/* Render Assigned Projects only if there are any */}
                                                        {assignedProjects.length > 0 && (
                                                            <Col lg={6} className="p-lg-4 h-100">
                                                                <h6 className="text-info">Assigned Projects</h6>
                                                                <hr/>
                                                                {assignedProjects.map((project) => (
                                                                    <ul key={project.Client_Project_id} className="mb-3 clt_proLink">
                                                                        <li>
                                                                            <b>{project.project_name}</b> <sub className="text-danger"> / {project.formSubmission?.type}</sub>
                                                                            <div className="cltp_st">
                                                                                {/* <Badge severity={getStatusSeverity(project.project_status)}>{project.project_status}</Badge> */}
                                                                                <Badge className={`badge bg-${getStatusClass(project.project_status)}`}>
                                                                                    {project.project_status.replace(/_/g, ' ')}
                                                                                </Badge>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                                                <p>
                                                                                    <span>Client name</span>
                                                                                    {project.client?.Billing_name}
                                                                                </p>
                                                                                <p>
                                                                                    <span>Email</span>
                                                                                    {project.client?.email}
                                                                                </p>
                                                                                <p>
                                                                                    <span>Phone</span>
                                                                                    {project.client?.phone}
                                                                                </p>
                                                                            </div>
                                                                        </li>
                                                                        <li className="d-flex justify-content-between align-items-center">
                                                                            <div>
                                                                                <Tag value={project.payment_status} severity={getStatusSeverity(project.payment_status)} />
                                                                            </div>
                                                                            <div>
                                                                                <Button
                                                                                    title="Link Project"
                                                                                    icon="pi pi-link"
                                                                                    className="py-1 me-2 border-0"
                                                                                    severity="danger"
                                                                                    outlined
                                                                                    onClick={() =>
                                                                                        handleLinkToEmployeeProject(project.Client_Project_id)
                                                                                    }
                                                                                />
                                                                                {" "}
                                                                                <Button
                                                                                    title="Update Status"
                                                                                    icon="pi pi-pencil"
                                                                                    className="py-1 border-0"
                                                                                    severity="help"
                                                                                    outlined
                                                                                    onClick={() => handleUpdateStatus(project.Client_Project_id)}
                                                                                />
                                                                            </div>
                                                                            
                                                                        </li>
                                                                    </ul>
                                                                ))}
                                                            </Col>
                                                        )}

                                                        {/* Render Unassigned Projects only if there are any */}
                                                        {unassignedProjects.length > 0 && (
                                                            <Col lg={6} className="p-lg-4 bg-light">
                                                                <h6 className="text-warning">Unassigned Projects</h6>
                                                                <hr/>
                                                                {unassignedProjects.map((project) => (

                                                                <ul key={project.Client_Project_id} className="mb-3 clt_proLink bg-white">
                                                                    <li>
                                                                        <b>{project.project_name}</b> <sub className="text-danger"> / {project.formSubmission?.type}</sub>
                                                                        <div className="cltp_st">
                                                                            {/* <Badge severity={getStatusSeverity(project.project_status)}>{project.project_status}</Badge> */}
                                                                            <Badge className={`badge bg-${getStatusClass(project.project_status)}`}>
                                                                                {project.project_status.replace(/_/g, ' ')}
                                                                            </Badge>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                                            <p>
                                                                                <span>Client name</span>
                                                                                {project.client?.Billing_name}
                                                                            </p>
                                                                            <p>
                                                                                <span>Email</span>
                                                                                {project.client?.email}
                                                                            </p>
                                                                            <p>
                                                                                <span>Phone</span>
                                                                                {project.client?.phone}
                                                                            </p>
                                                                        </div>
                                                                    </li>
                                                                    <li className="d-flex justify-content-between align-items-center">
                                                                        <div>
                                                                            <Tag value={project.payment_status} severity={getStatusSeverity(project.payment_status)} />
                                                                        </div>
                                                                        <div>
                                                                            <Button
                                                                                title="Link Project"
                                                                                icon="pi pi-link"
                                                                                className="py-1 me-2 border-0"
                                                                                severity="danger"
                                                                                outlined
                                                                                onClick={() =>
                                                                                    handleLinkToEmployeeProject(project.Client_Project_id)
                                                                                }
                                                                            />
                                                                            {" "}
                                                                            <Button
                                                                                title="Update Status"
                                                                                icon="pi pi-pencil"
                                                                                className="py-1 border-0"
                                                                                severity="help"
                                                                                outlined
                                                                                onClick={() => handleUpdateStatus(project.Client_Project_id)}
                                                                            />
                                                                        </div>
                                                                        
                                                                    </li>
                                                                </ul>




                                                                    // <Card key={project.Client_Project_id} className="mb-3">
                                                                    //     <Card.Header> {project.project_name} - {project.formSubmission?.type}</Card.Header>
                                                                    //     <Card.Body>

                                                                    //         <Card.Text>
                                                                    //             <strong>Client name:</strong> {project.client?.Billing_name} <br />
                                                                    //             <strong>Email:</strong> {project.client?.email} <br />
                                                                    //             <strong>Phone:</strong> {project.client?.phone} <br />
                                                                    //             <strong>Status:</strong> {project.project_status} <br />
                                                                    //             <strong>Payment Status:</strong> {project.payment_status}
                                                                    //         </Card.Text>

                                                                    //     </Card.Body>
                                                                    //     <Card.Footer className="d-flex justify-content-end">

                                                                    //         <Button
                                                                    //             label="Link to Employee Project"
                                                                    //             className="py-2 me-2"
                                                                    //             severity="info"
                                                                    //             text
                                                                    //             onClick={() =>
                                                                    //                 handleLinkToEmployeeProject(project.Client_Project_id)
                                                                    //             }
                                                                    //         />
                                                                    //         {" "}
                                                                    //         <Button
                                                                    //             label="Update Status"
                                                                    //             className="py-2 me-2"
                                                                    //             severity="help"
                                                                    //             text
                                                                    //             onClick={() => handleUpdateStatus(project.Client_Project_id)}
                                                                    //         />
                                                                    //     </Card.Footer>
                                                                    // </Card>
                                                                ))}
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </Card>
                                            </Tab>
                                        );
                                    })}
                                </Tabs>
                            )}
                        </Col>
                    </Row>
                </Row>
            )}


            {/* Link to Employee Project Modal */}
            <Dialog visible={showLinkModal} onHide={() => setShowLinkModal(false)} header="Link to Employee Project">
                <div className="p-fluid">
                    <div className="d-flex justify-content-between">
                        <Form.Group className="w-50 mx-2">
                            <Form.Label>Brand</Form.Label>
                            <AutoComplete
                                className="w-100 "
                                value={selectedBrand}
                                suggestions={brandSuggestions}
                                completeMethod={(e) => {
                                    fetchBrandsAndProjects(e.query);
                                    searchBrands(e);
                                }}
                                onChange={(e) => setSelectedBrand(e.value)}
                                field="name"
                                placeholder="Search Brand"
                            />
                        </Form.Group>
                        <Form.Group className="w-50 mx-2">
                            <Form.Label>Project</Form.Label>
                            <Form.Select
                                value={selectedProject}
                                onChange={(e) => setSelectedProject(e.target.value)}
                            >
                                <option value="">Select Project</option>
                                {addprojects.map((project) => (
                                    <option key={project.project_id} value={project.project_id}>
                                        {project.project_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    {/* Show additional fields after project selection */}
                    {selectedProject && (
                        <>
                            <div className="p-field mb-3 mt-3">
                                <label htmlFor="projectName">Project Name</label>
                                <InputText
                                    id="projectName"
                                    value={projectName}
                                    onChange={(e) => setProjectName(e.target.value)}
                                    className="w-100"
                                />
                            </div>

                            <div className="p-field mb-3">
                                <label htmlFor="deadline">Estimated Deadline</label>
                                <Calendar
                                    id="deadline"
                                    value={estimatedDeadline}
                                    onChange={(e) => setEstimatedDeadline(e.value)}
                                    className="w-100"
                                />
                            </div>
                        </>
                    )}


                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button label="Cancel" severity="danger" className="py-2 me-2" onClick={() => setShowLinkModal(false)} />
                        <Button label="Confirm" severity="help" className="py-2 me-2" onClick={handleSubmit} disabled={!projectName || !estimatedDeadline} />
                    </div>
                </div>
            </Dialog>

            {/* Update Status Modal */}
            <Dialog visible={showStatusModal} onHide={() => {
                setShowStatusModal(false);
                setModalStep('choose');
            }} header={
                modalStep === 'choose' ? 'Choose Action' :
                    modalStep === 'projectStatus' ? 'Update Project Status' :
                        'Update Payment Status'
            } >
                <div className="p-3">
                    {modalStep === 'choose' && (
                        <div className="d-flex justify-content-center align-items-center">
                            <Button label="Update Project Status" severity="info" className="py-2 me-2" onClick={() => setModalStep('projectStatus')} />
                            <Button label="Update Payment Status" severity="warning" className="py-2 me-2" onClick={() => setModalStep('paymentStatus')} />
                        </div>
                    )}

                    {modalStep === 'projectStatus' && (
                        <div>
                            <Dropdown
                                value={null}
                                options={[
                                    { label: 'Accepted', value: 'Accepted' },
                                    { label: 'Work under progress', value: 'Work_under_progress' },
                                    { label: 'Completed', value: 'Completed' },
                                    { label: 'On Hold', value: 'On_Hold' },
                                    { label: 'Rejected', value: 'Rejected' }
                                ]}
                                onChange={(e) => handleProjectStatusUpdate(e.value)}
                                placeholder="Select Project Status"
                                className="w-full"
                            />
                            <Button label="Back" severity="danger" className="p-button-text mt-3" onClick={() => setModalStep('choose')} />
                        </div>
                    )}

                    {modalStep === 'paymentStatus' && (
                        <div>
                            <Dropdown
                                value={null}
                                options={[
                                    { label: 'Payment due', value: 'Payment_due' },
                                    { label: 'Payment Completed', value: 'Payment_Completed' },
                                    { label: 'Partial Payment', value: 'Partial_Payment' },
                                    { label: 'Refunded', value: 'Refunded' }
                                ]}
                                onChange={(e) => handlePaymentStatusUpdate(e.value)}
                                placeholder="Select Payment Status"
                                className="w-full"
                            />
                            <Button label="Back" severity="danger" className="p-button-text mt-3" onClick={() => setModalStep('choose')} />
                        </div>
                    )}
                </div>
            </Dialog>


        </>
    );
};

export default Client_Project_Page;
